import { render, staticRenderFns } from "./privacySetting.vue?vue&type=template&id=f2fc2838&scoped=true"
import script from "./privacySetting.vue?vue&type=script&lang=js"
export * from "./privacySetting.vue?vue&type=script&lang=js"
import style0 from "./privacySetting.vue?vue&type=style&index=0&id=f2fc2838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fc2838",
  null
  
)

export default component.exports